<div class="header-bar">
  <div class="header-left">
    <div class="header-text">{{ editId ? 'Edit Campaign' : 'Create Campaign' }}</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>

<div class="campaign-create">
  <div class="container campaign-create-container">
    <div class="container-content">

      <div *ngIf="step === 1" class="step">
        <form [formGroup]="step1Form" class="step-form">
          <mat-form-field appearance="fill" class="full">
            <mat-label>Campaign Name</mat-label>
            <input matInput formControlName="name" placeholder="Name">
          </mat-form-field>

          <div class="section-title">Audience</div>
          <mat-radio-group formControlName="audienceMode" (change)="onAudienceChanged()" class="audience-modes">
            <mat-radio-button value="all">All Customers</mat-radio-button>
            <mat-radio-button value="search">Search Customers</mat-radio-button>
            <mat-radio-button value="saved">Saved Customer Search</mat-radio-button>
          </mat-radio-group>
          <div class="field-gap"></div>

          <div *ngIf="step1Form.value.audienceMode === 'search'" class="audience-action">
            <button mat-button color="lightGreen" (click)="openCustomerSearch(); $event.preventDefault()">Open Customer Search</button>
          </div>
          <div *ngIf="step1Form.value.audienceMode === 'search'" class="field-gap"></div>
          <div *ngIf="step1Form.value.audienceMode === 'saved'">
            <mat-form-field appearance="fill" class="full">
              <mat-label>Saved Customer Search</mat-label>
              <mat-select formControlName="savedSearchId" (selectionChange)="onSavedSearchSelected($event.value)">
                <mat-option *ngFor="let s of savedSearches" [value]="s.id">{{ s.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="audience-count" *ngIf="audienceCount !== null">Matches: {{ audienceCount | number }}</div>

          <div class="actions">
            <button mat-raised-button color="lightGreen" (click)="continue()" [disabled]="!step1Form.valid">Continue</button>
          </div>
        </form>
      </div>

      <div *ngIf="step === 2" class="step">
        <div class="form-and-preview">
          <form [formGroup]="step2Form" class="form">
            <mat-form-field appearance="fill" class="full">
              <mat-label>Email Description</mat-label>
              <textarea matInput formControlName="prompt" rows="6" placeholder='Briefly describe the purpose of the email so the Luma knows what to write. For example “This is a marketing email to encourage players to visit the property in the next week.”'></textarea>
            </mat-form-field>
            <div class="field-gap"></div>

            <mat-radio-group aria-label="Generate Subject" formControlName="generateSubject" (change)="generateSubjectChange()">
              <mat-label>Generate personalized subject line for each recipient?</mat-label> &nbsp;
              <mat-radio-button class="mat-lightGreen" value="yes">Yes</mat-radio-button>
              <mat-radio-button class="mat-lightGreen" value="no">No</mat-radio-button>
            </mat-radio-group>
            <div class="field-gap"></div>

            <mat-form-field appearance="fill" class="full">
              <mat-label>Subject</mat-label>
              <input matInput formControlName="subject" [disabled]="step2Form.value.generateSubject === 'yes'">
            </mat-form-field>

            <div *ngIf="step2Form.value.generateSubject === 'yes'">
              <div class="instruct">Select which profile trait to feature in the subject line (choose one):</div>
              <lhpe-select
                controlName="subjectField"
                placeholder="Choose One"
                [formGroup]="step2Form!"
                [required]="true"
                [options]="profileFields"
                optionValue="id"
                [multiple]="false"
                (change)="subjectFieldChange($event)"
              >
              </lhpe-select>
            </div>
            <div *ngIf="step2Form.value.generateSubject === 'yes'" class="field-gap"></div>

            <div>
              <div class="instruct" *ngIf="step2Form.value.generateSubject === 'no'">Select which profile traits to include in the body of the email (three max):</div>
              <div class="instruct" *ngIf="step2Form.value.generateSubject === 'yes'">Select which profile traits to include in the body of the email (two additional max):</div>
              <mat-chip-list>
                <mat-chip *ngFor="let field of profileFields" (click)="bodyFieldClick(field.id)" [ngClass]="{ 'active-chip': highlightBodyField(field.id) }">
                  {{ field.name }}
                  <mat-icon matChipRemove *ngIf="removableBodyField(field.id)" (click)="removeBodyField(field.id)">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </div>
            <div class="field-gap"></div>

          </form>

          <div class="preview" *ngIf="preview">
            <div class="section-title">Preview</div>
            <img *ngIf="logoUrl" [src]="logoUrl" alt="Preview logo" class="preview-logo" />
            <h3 class="preview-subject">Subject: {{ preview.subject }}</h3>
            <div class="preview-body" [innerHTML]="preview.body"></div>
          </div>

          <div class="actions actions-left">
            <button mat-stroked-button color="lightGreen" (click)="generatePreview()" [disabled]="disableGeneratePreview() || isGenerating">Generate Preview</button>
          </div>
          <div class="actions actions-right" *ngIf="preview">
            <button mat-raised-button color="lightGreen" (click)="saveCampaign()" [disabled]="step2Form.invalid || editLocked">{{ editId ? 'Save Changes' : 'Save Campaign' }}</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


